<template>
  <div class="home">
    <div class="main-bg">
      <div class="main-wrap">
        <div class="index-part1">
          <!--@mouseover="isShowTypeList=true"-->
          <div class="type-left" @mouseout="typeActive=0">
            <ul class="goodsType">
              <li class="first-tab" v-for="(item,index) in allTypeList" :key="index" @mouseover="typeActive=item.id">
                <div class="first-name" :class="{'active':typeActive==item.id}" @click="$router.push({name:'商品搜索',params:{oneTypeId:item.id,oneTypeName:item.typeName}})">
                  <div class="first-txt">{{item.typeName}} <i class="fr el-icon-arrow-right arrow"></i></div>
                </div>
                <!--<ul class="sub-tab" v-if="item.twoTypes.length!==0">
                  <li v-for="(v,subIndex) in item.twoTypes" :key="subIndex" @click="$router.push({name:'商品搜索',params:{oneTypeId:item.id,oneTypeName:item.typeName,twoTypeId:v.id,twoTypeName:v.typeName}})">{{v.typeName}}</li>
                </ul>-->
              </li>
            </ul>
            <div class="type-float" v-show="typeActive">
              <ul class="sub-tab" v-show="typeActive==item.id" v-for="(item,index) in allTypeList" :key="index"  @mouseover.stop="typeActive=item.id">
                <li v-for="(v,subIndex) in item.twoTypes" :key="subIndex" @click="$router.push({name:'商品搜索',params:{oneTypeId:item.id,oneTypeName:item.typeName,twoTypeId:v.id,twoTypeName:v.typeName}})">{{v.typeName}}</li>
              </ul>
            </div>
          </div>

          <div class="banner-r">
            <el-carousel :interval="5000" arrow="never" height="478px">
              <el-carousel-item v-for="(item,index) in bannerList" :key="index"  @click="goUrl(item.type,item.otherId)">
                <el-image :src="$common.imgPath(item.img)" :alt="item.id" style="width:100%;"></el-image>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
        <!--广告位招租-->
        <ul class="index-part2">
          <!--<router-link tag="li"  v-for="(item,index) in advertisementList" :key="index" :to="{path:`/shop/detail/${item.shopId}`}">
            <img class="shop-img" :src="$common.imgPath(item.img)" :alt="item.shopId">
          </router-link>-->
          <li v-for="(item,index) in advertisementList" :key="index" @click="$router.push({ path: `/shop/detail/${item.shopId}` })">
            <el-image class="shop-img" :src="$common.imgPath(item.img)" :alt="item.shopId" lazy></el-image>
          </li>
          <!--<li>
            <p class="name">广告位招租中...</p>
            <p class="tel">联系：15520262361</p>
          </li>-->
        </ul>
        <!--推荐拍品-->
        <div class="index-part3">
          <h3 class="title">最新拍品</h3>
          <GoodsItem :goodsList="newLotList" :nowTime="nowTime"></GoodsItem>
        </div>
        <!--下载APP-->
        <div class="index-part4 mb20"></div>
        <div class="index-part5">
          <div class="item fl tab-left">
            <div class="list-name"><h3 class="tit">兰花拍卖</h3><a class="btn-more" @click="$router.push({path:'/search'})">更多</a></div>
            <ul class="table-head"><li>名称</li><li>起拍价</li><li>最新价格</li><li>分类</li><li>卖家</li></ul>
            <ul class="table-list" v-for="(l,i) in orchidList" :key="i" @click="$router.push({'path':`/goods/detail/${l.id}`})">
              <li class="color-blue">{{l.goodsName}}</li>
              <li>¥{{l.startPrice}}</li>
              <li>{{l.price}}</li>
              <li class="color-blue">{{l.oneType.typeName}}/{{l.twoType.typeName}}</li>
              <li class="color-blue">{{l.shop.celebrityName}}</li>
            </ul>

          </div>
          <div class="item fr tab-right">
            <div class="list-name"><h3 class="tit">植料／其他</h3><a class="btn-more" @click="$router.push({path:'/search'})">更多</a></div>
            <ul class="table-head cell-four"><li>名称</li><li>价格</li><li>分类</li><li>卖家</li></ul>
            <ul class="table-list cell-four" v-for="(l,i) in orchidOtherList" :key="i" @click="$router.push({'path':`/goods/detail/${l.id}`})">
              <li class="color-blue">{{l.goodsName}}</li>
              <li>{{l.price}}</li>
              <li class="color-blue">{{l.oneType.typeName}}/{{l.twoType.typeName}}</li>
              <li class="color-blue">{{l.shop.celebrityName}}</li>
            </ul>
            <!--<ul class="table-list">
              <li class="color-blue">黑皮木纹！草厚！起夹.</li>
              <li>¥0</li>
              <li class="color-blue">蕙兰/其他</li>
              <li class="color-blue">玉兰香</li>
            </ul>-->
          </div>
        </div>
        <ul class="index-part6">
          <li class="left-logo" @click="$router.push({'path':'/celebrity'})">
            <h3>名人名兰</h3>
            <span class="line"></span>
            <p>celebrity</p>
            <a class="btn-right"><i class="el-icon-arrow-right"></i></a>
          </li>
          <li class="item" v-for="(g,i) in celebrityList" :key="i" @click="$router.push({'path':`/celebrity/detail/${g.shopId}`})">
            <el-image  class="img" :src="$common.imgPath(g.celebrityImg?g.celebrityImg:g.headImg)" :alt="g.id" lazy fit="cover"></el-image>
            <p class="name">{{g.celebrityName?g.celebrityName:g.shopName}}</p>
            <p class="desc" :title="g.celebrityIdentity">{{g.celebrityIdentity}}</p>
          </li>
          <li class="right" @click="$router.push({'path':'/celebrity'})"><i class="el-icon-arrow-right"></i></li>
        </ul>
        <div class="index-part7">
          <OrchidList></OrchidList>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
// @ is an alias to /src
import {getBannerList,getAdvertisementList} from '../api/banner'
import {getIndexTypeAll,findByShopIdForShop} from '../api/goods'
import {getCelebrityPage} from '../api/shop'
export default {
  name: 'Home',
    data(){
      return {
          typeActive:0,//高亮显示当前分类
          isShowTypeList:false,//是否显示分类列表
          allTypeList:[],//全部分类列表
          bannerList:[],//banner图
          advertisementList:[],//广告列表
          newLotList:[],//最新拍品列表
          nowTime:'',//获取服务器当前时间倒计时
          orchidList:[],//兰花拍卖
          orchidOtherList:[],//物料/其他
          celebrityList:[]//名人列表
      }
    },
  components: {
      GoodsItem:() => import('../components/goods/goodsItem'),
      OrchidList:() => import('../components/orchid/screen')
  },
    created(){
        this.getIndexTypeAll();
        this.getBannerList();
    },
    mounted(){
    },
    methods:{
        goUrl(type,otherId){
            switch (type){
                case 1:
                    this.$router.push({path:'/shop/detail/'+otherId});
                    break;
                case 2:
                    this.$router.push({path:'/goods/detail/'+otherId});
                    break;
            }

        },
        getIndexTypeAll(){
            getIndexTypeAll().then(res=>{
                if(res.data)this.allTypeList=res.data;
              console.log("getIndexTypeAll",res);
          })
        },
        getBannerList(){
            getBannerList().then(res=>{
                this.bannerList=res.data;
                this.getAdvertisementList();
            })
        },
        getAdvertisementList(){
            getAdvertisementList().then(res=>{
                this.advertisementList=res.data;
                this.getTuiJianPaiPinList();
            })
        },
        getTuiJianPaiPinList(){
            findByShopIdForShop({
                current:1,
                size:8,
                goodsType:2,
                status:1,
                rank:1
            }).then(res=>{
                this.newLotList=res.data.records;
                this.nowTime=res.nowTime;
                this.getOrchidList(1);//植物/其他
                this.getOrchidList(2);//兰花拍卖
                this.getCelebrityList();//获取名人列表
            })
        },
        getOrchidList(goodsType){
            findByShopIdForShop({
                current:1,
                size:2,
                goodsType:goodsType,
                status:1,
                rank:2
            }).then(res=>{
                if(res.data){
                    goodsType==2?this.orchidList=res.data.records:this.orchidOtherList=res.data.records
                }
            })
        },
        getCelebrityList(){
            getCelebrityPage({
                current:1,
                size:8,
                rank:2
            }).then(res=>{
                if(res.data)this.celebrityList=res.data.records;
            })
        }
    }
}
</script>
<style scoped lang="scss">
  @import "../assets/css/common";
  .home{
    .main-bg{
      background-color:#f7f6f9;
      .main-wrap{
        .index-part1{
          position: relative;
          height:478px;
        }
        .index-part2{
          padding:17px 0 34px;
          overflow: hidden;
          li{
            float: left;
            width:280px;
            height:150px;
            line-height:30px;
            background-color:#7F2D00;
            text-align: center;
            cursor: pointer;
            .shop-img{width:100%;height:100%;}
            /*.name{color:yellow;margin-top:50px;}
            .tel{color: #ffffff;}*/
            &+li{
              margin-left:26.5px;
            }
          }
        }
        .index-part3{
          .title{font-size:24px;color:#1F1F1F;}

        }
        .index-part4{
          width:100%;
          height:121px;
          background:url("../assets/images/index-down-app.png")no-repeat center;
        }
        .index-part5{
          overflow: hidden;
          .item{
            width:590px;
            .list-name{
              background-color:#ffffff;
              padding:13px;
              overflow: hidden;
              .tit{color:#1F1F1F;font-size:24px;
                float: left;}
              .btn-more{
                @include hover-color;
                float: right;
                width:76px;
                height:32px;
                line-height:32px;
                text-align:center;
                color:#393A3D;
                font-size:16px;
                border:1px solid #DDDDDD;
                -webkit-border-radius: 16px;
                -moz-border-radius: 16px;
                border-radius: 16px;}
            }
            .table-head{
              padding:0 20px;
              height:53px;
              line-height:53px;
              color:#707070;
              font-size:15px;
              background-color:#F7F7F7;
              li{
                float: left;
                width:18.5%;
                text-align: center;
                &:first-child{width:26%;text-align: left;}
              }
              &.cell-four li{
                width:25%;
              }
            }
            .table-list{
              padding:15px 20px 0;
              font-size:14px;
              color:#000000;
              background-color:#ffffff;
              overflow: hidden;
              cursor: pointer;
              li{
                float: left;
                width:18.5%;
                text-align: center;
                white-space:nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
                &:first-child{width:26%;text-align: left;}
                padding-bottom:18px;
                &.color-blue{color: #1457D1}
              }
              &.cell-four li{
                width:25%;
              }
            }
          }
          .tab-left{

          }
        }
        .index-part6{
          overflow: hidden;
          margin:21px 0 23px;
          background-color:#ffffff;
          li{
            float: left;
            &.item{
              &:hover{
                cursor: pointer;}
              width:110px;
              height:147px;
              padding:21px 8px;
              text-align: center;
              color:#000;
              .img{
                width:100px;
                height:100px;
                margin:0 auto;
                background-color:$main-color;
                -webkit-border-radius: 10px;
                -moz-border-radius: 10px;
                border-radius: 10px;
              }
              .name{font-size:15px;padding:10px 0 6px;}
              .desc{
                font-size:12px;
                text-overflow: -o-ellipsis-lastline;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                line-clamp: 2;
                -webkit-box-orient: vertical;
              }
            }
            &.left-logo{
              width:138px;
              height:189px;
              background-color:$main-color;
              color:#ffffff;
              text-align: center;
              margin-right:18px;
              h3{font-size:22.55px;padding-top:41px;}
              .line{
                display: block;
                width:30px;
                height:2px;
                background-color:#ffffff;
                margin:5px auto;
              }
              p{font-size:16.28px;}
              .btn-right{
                display: block;
                width:23.7px;
                height:23.7px;
                line-height:23.7px;
                text-align: center;
                color:#ffffff;
                margin:20px auto 0;
                -webkit-border-radius: 50%;
                -moz-border-radius: 50%;
                border-radius: 50%;
                border:2px solid rgba(255,255,255,1);

              }
            }
            &.right{
              float: right;
              color:#D3D3D3;
              font-size:24px;
              margin:62px 12px 0 0;
            }
          }
        }
        .index-part7{
          background-color:#ffffff;
          .type-nav{
            overflow: hidden;
            padding:12px 0;
            border-bottom:1px solid #F3F3F3;
            li{
              float: left;
              height:16px;
              color:#AEAEAE;
              font-size:15px;
              padding:0 36px;
              border-right:1px solid #D7D7D7;
              &.active{
                color: $main-color;
                position: relative;
                &:after{
                  content: '';
                  position: absolute;
                  width:31px;
                  height:3px;
                  left:50%;
                  bottom:-10px;
                  margin-left:-15px;
                  background-color:$main-color;
                  -webkit-border-radius: 1.5px;
                  -moz-border-radius: 1.5px;
                  border-radius: 1.5px;
                }
              }
            }
          }
          .goods-list{
            overflow: hidden;
            padding:20px 20px 0;
            li{
              color:#6F6F6F;
              float: left;
              width:20%;
              margin-bottom:10px;
              overflow: hidden;
              .img{
                float: left;
                width:60px;
                height:60px;
                background-color:$main-color;
                -webkit-border-radius: 10px;
                -moz-border-radius: 10px;
                border-radius: 10px;
              }
              .desc{
                float: left;
                padding-left:13px;
                .name{font-size:16px;padding:9px 0 10px;}
                .desc-txt{font-size:12px;}
              }
            }
          }
        }
      }
      .type-left{
        position: absolute;
        left: 0;
        top: 0;
        z-index: 1000;
        /*width: 395px;*/
        height: 478px;
      }
      .goodsType{
        position: absolute;
        left:0;
        top:0;
        line-height: 33px;
        background-color: #ffffff;
        font-size: 14px;
        height: 100%;
        overflow: scroll;
        &>li{
          &+li{
            border-top:1px dashed #EAEAEA;
          }
          width:210px;
          color:#000000;
          &:hover,.active{
            .first-txt{background-color:$main-color;color: #ffffff;cursor: pointer;
              font-weight:600;}
            /*&.first-tab .sub-tab{
              display: block;
            }*/
          }
          .first-txt{
            padding:5px 8px 5px 12px;
          }
          &.first-tab{
            position: relative;
            /*padding-top:5px;*/
            /*padding-bottom:5px;*/
            .arrow{
              color:#D3D3D3;
              margin-top:10px;
            }



          }


        }
      }
      .type-float{
        position: absolute;
        left: 210px;
        top: 0;
        width:185px;
        height:478px;
        z-index: 22;
        background-color:#F7F7F7;
      }
      .sub-tab{
        font-size:14px;
        color:#222222;
        padding:0 10px;
        background-color:#F7F7F7;
        position: absolute;
        left:0;
        top:0;
        width:calc(100% - 20px);
        height: 100%;
        /*display: none;*/
        text-align: center;
        white-space:nowrap;
        transform: translateZ(0);
        &>li{
          float: left;
          width: 50%;
          line-height: 30px;
          text-align: center;
          padding-top:5px;
          padding-bottom:5px;
          &:hover{color: $main-color;
            cursor: pointer;}
        }

      }
      .banner-r{
        position: absolute;
        width:990px;
        top:0;
        right:0;
      }
      .el-carousel__item h3 {
        color: #475669;
        font-size: 14px;
        opacity: 0.75;
        line-height: 200px;
        margin: 0;
      }

      .el-carousel__item:nth-child(2n) {
        background-color: #99a9bf;
      }

      .el-carousel__item:nth-child(2n+1) {
        background-color: #d3dce6;
      }
    }
  }
</style>
<style lang="scss">
  @import "../assets/css/common";
  .el-carousel__button{
    width:12px;
    height:12px;
    background:rgba(255,255,255,1);
    opacity:0.45;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    border-radius: 50%;
  }
  .el-carousel__indicator.is-active button{
    background:$main-color;
    opacity:1;
  }
</style>
